import type { DayOfWeek, MealPlan, MealType } from '../types';

export function buildMealSlotTitleKey(day: DayOfWeek, mealType: MealType): string {
    return `${day}_${mealType}`;
}

export function getMealSlotCustomTitle(
    plan: MealPlan | undefined | null,
    day: DayOfWeek | undefined,
    mealType: MealType,
): string | undefined {
    if (!plan?.slotMenuTitles || !day) {
        return undefined;
    }

    const title = plan.slotMenuTitles[buildMealSlotTitleKey(day, mealType)]?.trim();
    return title || undefined;
}

export function getDefaultSlotHeaderLabel(
    mealType: MealType,
    t: (key: string) => string,
): string {
    if (mealType === 'Breakfast') return t('morning');
    if (mealType === 'Lunch') return t('noon');
    return t('evening');
}

export function getDefaultMenuTitle(
    mealType: MealType,
    day: DayOfWeek | undefined,
    t: (key: string) => string,
): string {
    const mealLabel = t(mealType.toLowerCase());
    const dayLabel = day ? t(`day_${day}`) : '';
    return dayLabel ? `${mealLabel} · ${dayLabel}` : mealLabel;
}

export function resolveMealMenuTitle(
    plan: MealPlan | undefined | null,
    day: DayOfWeek | undefined,
    mealType: MealType,
    t: (key: string) => string,
): string {
    return getMealSlotCustomTitle(plan, day, mealType) ?? getDefaultMenuTitle(mealType, day, t);
}

export function resolveMealSlotHeaderTitle(
    plan: MealPlan | undefined | null,
    day: DayOfWeek,
    mealType: MealType,
    t: (key: string) => string,
): string {
    return getMealSlotCustomTitle(plan, day, mealType) ?? getDefaultSlotHeaderLabel(mealType, t);
}
